// FA204 / frank trap — OVERLAY_STATE_KEYS used to be a bare module-scope
// const, read from inside this exported function's own body: unresolvable
// once this file's exports are individually frank.toJSON'd for platform
// delivery (project_frank_drops_module_local_helpers). Inlined as a local —
// no other export in this file needs it, so no duplication required.
export const headerOverlayPatch = (activeOverlay, opening, extra = {}) => {
  const OVERLAY_STATE_KEYS = {
    assistant: 'assistantOpen',
    chat: '_chatDrawerOpen',
    mail: '_mailDrawerOpen',
    notifications: 'notificationsPanelOpen'
  }
  const activeKey = OVERLAY_STATE_KEYS[activeOverlay]
  if (!activeKey) return { ...extra }

  const patch = { [activeKey]: opening, ...extra }
  if (!opening) return patch

  for (const [overlay, stateKey] of Object.entries(OVERLAY_STATE_KEYS)) {
    if (overlay !== activeOverlay) patch[stateKey] = false
  }
  return patch
}
